import { useState, useEffect, useCallback } from 'react'
import { supabase, isSupabaseConfigured } from '@/lib/supabase'

export function useOnboarding() {
  const [needsOnboarding, setNeedsOnboarding] = useState(false)
  const [needsSupabaseSetup, setNeedsSupabaseSetup] = useState(false)
  const [checking, setChecking] = useState(true)

  const checkOnboarding = useCallback(() => {
    // If Supabase is not configured, we need setup first
    if (!isSupabaseConfigured()) {
      setNeedsSupabaseSetup(true)
      setNeedsOnboarding(true)
      setChecking(false)
      return
    }

    setNeedsSupabaseSetup(false)

    supabase.from('lenses').select('id').limit(1)
      .then(({ data }) => {
        setNeedsOnboarding(!data || data.length === 0)
        setChecking(false)
      }, () => {
        setChecking(false)
      })
  }, [])

  useEffect(() => {
    const timer = setTimeout(checkOnboarding, 0)
    return () => clearTimeout(timer)
  }, [checkOnboarding])

  const completeOnboarding = () => setNeedsOnboarding(false)
  
  // Called after Supabase is configured to re-check
  const recheckAfterSetup = () => {
    setChecking(true)
    // Small delay to ensure localStorage is updated
    setTimeout(checkOnboarding, 100)
  }

  return { needsOnboarding, needsSupabaseSetup, checking, completeOnboarding, recheckAfterSetup }
}
